var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apprentice-simple-card skilltree-edit"},[_c('design-2021-orgchart-component',{attrs:{"nodes-in":_vm.nodes,"skill-tree-in":_vm.skillTreeIn,"rubrics-in":_vm.rubricsIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }